
import { Component, Vue, Watch } from "vue-property-decorator";
import { RankingList, StatisticalData, deviceStatus } from "@/views/components";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import config from "./config";
import Form1 from "./Form1.vue";
import Form2 from "./Form2.vue";
import TableHeader from "./TableHeader.vue";

@Component({
  name: "scanfordepartcar",
  components: {
    deviceStatus,
    RankingList,
    StatisticalData,
    YtoTable,
    Form1,
    Form2,
    TableHeader,
    Scan
  }
})
export default class extends Vue {
  private inputModel: inputDataModel_Depart = {
    checked_NextOrgCode: false,
    input_ScanCode: "",
    input_CarSignNum: "",
    input_LineNo: "",
    input_LineName: "",
    input_NextOrgCode: "",
    input_OrgName: "",
    checked_OverTimeCar: false,
    options_NextOrg: []
  };
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.asyncSendDataToNet(val);
  }
  @Watch("checked_IsOverTimeCar", { deep: false })
  onIsOverTimeCarChanged(val: boolean) {
    this.inputModel.checked_OverTimeCar = val;
  }
  mounted() {
    // //初始化设备状态
    // this.deviceItems = [];
    // for (let index = 1; index <= 12; index++) {
    //   this.deviceItems.push({
    //     name: "设备" + index.toString(),
    //     title: index.toString(),
    //     status: "defult",
    //   });
    // }

    //初始化统计数据栏目内显示的数据
    // this.statisticalList = [{ label: "总扫描数", value: "0", combine: "1" }];

    try {
      //注册设备状态回调函数
      //obj_ScanForArriveCar.regist_getdevicestate(this.getdevicestatecallback);
      obj_ScanForDepart.regist_datahistorycallback(this.datahistorycallback);
      obj_ScanForDepart.regist_errormsgcallback(this.errormsgcallback);
      obj_ScanForDepart.regist_statisticaldata(this.statisticaldatacallback);
      obj_ScanForDepart.regist_ranklistupdate(this.ranklistupdatecallback);
      obj_ScanForDepart.regist_updateformdata(this.updateformdatacallback);
    } catch (error) {
      console.log("发车界面:注册回调函数异常" + error);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }
  public ranklistdata: rankListModel = {
    avgEfficiency: "0",
    lastHourAvgEfficiency: "0",
    avgEfficiencyRank: "0",
    frequencyRank: "0",
    wholeTopEfficiency: "0"
  };
  public updateformdatacallback(data) {
    if (this.inputModel.input_CarSignNum != data.input_CarSignNum) {
      this.inputModel = data;
      this.callbackmodel = this.inputModel;
      return;
    }
    if (this.inputModel.input_LineNo != data.input_LineNo) {
      this.inputModel = data;
      this.callbackmodel = this.inputModel;
      return;
    }
    if (this.inputModel.input_LineName != data.input_LineName) {
      this.inputModel = data;
      this.callbackmodel = this.inputModel;
      return;
    }
    if (this.inputModel.input_OrgName != data.input_OrgName) {
      this.inputModel = data;
      this.callbackmodel = this.inputModel;
      return;
    }
    if (this.inputModel.input_NextOrgCode != data.input_NextOrgCode) {
      this.inputModel = data;
      this.callbackmodel = this.inputModel;
      return;
    }
    // if (this.inputModel.input_CarSignNum != data.input_CarSignNum) {
    //   this.inputModel = data;
    //   this.callbackmodel = this.inputModel;
    //   return;
    // }
    if (this.inputModel.options_NextOrg != data.options_NextOrg) {
      this.inputModel = data;
      this.callbackmodel = this.inputModel;
      return;
    }
  }
  //Form1界面回调
  public ranklistupdatecallback(dic) {
    this.ranklistdata = dic;
  }

  public asyncSendDataToNet(data) {
    // return new Promise((resolve, reject) => {
    return new Promise(() => {
      var result = obj_ScanForDepart.sendFormDataToNet(data);
    });
  }
  //上传成功,为黑色，其他都是红色
  private rowClassAction(row) {
    if (/失败/.test(row.row.UploadStateName)) {
      return { color: "#f22613", "font-size": "130%", "font-weight": "bold" };
    }
  }
  private getFormValue(element) {
    this.inputModel = element;
  }
  public checked_IsOverTimeCar = false;
  // private getForm2Value(element) {
  //this.inputModel.checked_OverTimeCar = element.checked_IsOverTimeCar;
  // }
  private currentRowChanged(element) {
    this.currentrow = element;
    this.callbackmodel = this.inputModel;
  }
  public deletedatahistory() {
    if (this.currentrow === null) {
      this.$message.warning("请先选择要删除的行");
      return;
    }
    this.$confirm("是否确定要删除此数据？", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(() => {
        console.log("执行删除以下数据的动作");
        try {
          if (obj_ScanForDepart.deleteClick(this.currentrow)) {
            this.currentrow = null;
          }
        } catch (error) {
          console.log("删除失败：" + error.message);
        }
      })
      .catch(() => {
        console.log("取消删除");
      });
  }
  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }
  //更新设备状态数据
  public getdevicestatecallback(datas): void {
    this.deviceItems = [];
    this.deviceItems = datas;
  }
  public index = 1;
  //更新数据列表的数据
  public datahistorycallback(data) {
    this.showList = [];
    this.showList = data;
  }
  //错误消息回调显示方法
  public errormsgcallback(data) {
    this.errormessage = data;
  }
  public totalScanCount = "0";
  //统计数据回显
  public statisticaldatacallback(data) {
    data.forEach(element => {
      if (element.Key == "totalScanCount") {
        // this.statisticalList[0].value = element.Value;
        this.totalScanCount = element.Value;
      }
    });

  }
  public msg = "";
  private config = config;
  // private statisticalList = [];
  public currentrow = null;
  public showList = [];
  public ytoCode = "";
  //扫描区扫码
  private ytocodeget() {
    this.inputModel.input_ScanCode = this.ytoCode.toUpperCase();
    // }
    try {
      obj_ScanForDepart.scanAreaClick(this.inputModel);
    } catch (error) {
      console.log(error.message);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }
  public callbackmodel = {};

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  private deviceItems: deviceItem[] = [];
  private errormessage = "";
}
